import React, {useCallback} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import {promoCodeAPI} from 'entities/tariff';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputName from 'shared/ui/Input/InputName';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';

interface IPromoCodeActivateFormProps {
    onSuccess: () => void;
    onClose: () => void;
}

interface IPromoCodeActivateFormState {
    value: string;
}

const PromoCodeActivateForm: React.FC<IPromoCodeActivateFormProps> = ({onSuccess, onClose}) => {
    const {register, control, handleSubmit, formState} = useForm<IPromoCodeActivateFormState>({
        mode: 'onChange',
    });
    const {isValid, errors} = formState;

    const dispatch = useDispatch<TypedDispatch>();
    const [activatePromoCode, {isLoading}] = promoCodeAPI.useActivatePromoCodeMutation();

    const onSubmit: SubmitHandler<IPromoCodeActivateFormState> = useCallback(async(formData) => {
        try {
            await activatePromoCode(formData).unwrap();
            await dispatch(fetchMe());
            toast.info(t`Промокод успешно активирован`);
            onSuccess();
        } catch (error) {
        }
    }, [activatePromoCode, dispatch, onSuccess]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <ModalBodyWrapper>
                <FormGroupWithError
                    label={t`Промокод`}
                    error={errors.value?.message}
                >
                    <InputName
                        control={control}
                        name="value"
                        placeholder={t`Введите промокод`}
                        register={register}
                    />
                </FormGroupWithError>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Активировать`}
                primaryButtonType="submit"
                primaryButtonLoading={isLoading}
                primaryButtonDisabled={!isValid || isLoading}
                secondaryButtonOnClick={onClose}
            />
        </form>
    );
};

export default PromoCodeActivateForm;
